var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCached(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.751953 1.45361V4.18083H3.48404",
    stroke: "#545E6C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7692 8.72624V5.99902H8.03711",
    stroke: "#545E6C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62667 3.72614C9.39573 3.07469 9.00323 2.49226 8.48581 2.03318C7.96838 1.57411 7.34289 1.25336 6.66769 1.10086C5.99249 0.948358 5.2896 0.96908 4.62459 1.16109C3.95959 1.3531 3.35415 1.71014 2.86476 2.1989L0.751953 4.18067M10.7696 5.99881L8.65678 7.98059C8.16739 8.46934 7.56195 8.82638 6.89695 9.01839C6.23194 9.21041 5.52905 9.23113 4.85385 9.07863C4.17865 8.92613 3.55316 8.60538 3.03573 8.1463C2.5183 7.68723 2.12581 7.1048 1.89487 6.45335",
    stroke: "#545E6C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCached);
export default __webpack_public_path__ + "static/media/cached.0a528489375df6d37e6824b996819f62.svg";
export { ForwardRef as ReactComponent };